import React from 'react';
import { AlertProps } from '../../types/category';
import styles from './Alert.module.css';

const Alert: React.FC<AlertProps> = ({ message, type, isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className={`${styles.alert} ${styles[`alert${type.charAt(0).toUpperCase() + type.slice(1)}`]}`}>
      <span>{message}</span>
      <button onClick={onClose} className={styles.alertClose}>×</button>
    </div>
  );
};

export default Alert; 